import { Component, h, ComponentInterface, State, Element } from '@stencil/core';
import { guid, _BREAKPOINTS_ } from 'utils';


@Component({
	tag: 'kdx-footer',
	styleUrl: 'kdx-footer.scss',
	shadow: false,
})
export class StFooter implements ComponentInterface {

	@Element() root: HTMLElement;

	@State() guid: string = guid();

	componentDidRender() {
		const year = new Date().getFullYear();
		const yearHTML = document.querySelector(".copyright .current-year") as HTMLElement;
		yearHTML.innerHTML = year.toString();
	}

	componentDidLoad() {
		const toggles = this.root.querySelectorAll('.js-toggle-heading');

		if (toggles) {
			toggles.forEach((toggle) => {
				toggle.addEventListener('click', this.toggleHeadings.bind(this))
			});
		}
	}

	toggleHeadings(e) {
		const linkList = e.currentTarget.nextElementSibling;
		const icon = e.currentTarget.querySelector('kdx-icon') as HTMLElement;
		e.preventDefault();

		if (linkList) {
			if (!linkList.classList.contains('show')) {
				e.currentTarget.classList.add('show');
				linkList.classList.add('show');
				icon.setAttribute('icon', 'minus');
			}
			else {
				e.currentTarget.classList.remove('show');
				linkList.classList.remove('show');
				icon.setAttribute('icon', 'plus');
			}
		}
	}

	render() {
		return (
		<footer class="kdx-footer">
			<slot />
		</footer>
		);
	}
}
